if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));


        if(document.querySelector(".product__custom_subsriptions_new")) {
          document.querySelector(".product__custom_subsriptions_new").addEventListener('click', function(e) {
            if (!e.target.classList.contains("button")) {
              return;
            }

            e.target.classList.add('loading');
            e.target.querySelector('.loading-overlay__spinner').classList.remove('hidden');

            if(e.target.dataset.extra) {
              let extra = JSON.parse(e.target.dataset.extra);
              let bundleID = `bundle-${crypto.randomUUID().split('-')[0]}`;
              this.onSubmitHandlerExtended(e, [
                { id: extra.variant_id, selling_plan: extra.sellingPlan_id, quantity: 1, properties: { _gift: 'true', _bundle: bundleID, _Product: 'Addon', _downgrade: extra.downgrade_variant_id} }
              ], bundleID);
            } else {
              this.onSubmitHandler(e, true);
            }
          }.bind(this));
        }


        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      manageCustomData(formData) {
        let addOptionData = {};
        let addOption = document.querySelector(".additional-option:checked");
        
        let singleProduct = false;
        let annualProduct = false;
        
        if(addOption) {
          addOptionData = JSON.parse(addOption.dataset.details);
          formData.delete('id');
          formData.append('id', addOptionData.variant_id);
          formData.delete('product-id');
          formData.append('product-id', addOptionData.product_id);

          if (addOptionData.selling_plan) {
            formData.delete('selling_plan');
            formData.append('selling_plan', addOptionData.selling_plan);
          }
          
          if(addOptionData.cart_message) {
            formData.delete(`properties[${ window.customOptions.cart_message }]`);
            formData.append(`properties[${ window.customOptions.cart_message }]`, addOptionData.cart_message);
          }
          
          if(addOptionData.checkout_message) {
            formData.delete(`properties[${ window.customOptions.checkout_message }]`);
            formData.append(`properties[${ window.customOptions.checkout_message }]`, addOptionData.checkout_message);
          }

          if(addOptionData["Credits"]) {
            formData.delete(`properties[Credits]`);
            formData.append(`properties[Credits]`, addOptionData["Credits"]);
          }

          if(!addOptionData.selling_plan) {
            singleProduct = true;
            formData.append(`properties[${ window.customOptions.product_type_key }]`, "Single");
          } else {
            formData.append(`properties[${ window.customOptions.product_type_key }]`, "Subscription");
          }
          
          if(addOptionData.qty) {
            formData.delete('quantity');
            formData.append('quantity', addOptionData.qty);
          }
        }
        
        return {formDataUpdated: formData, annualProduct: annualProduct, singleProduct: singleProduct};
      }

      updateCreditsProperty() {
        const creditsInput = this.form.querySelector('input[name="properties[Credits]"]');
        if (!creditsInput || !creditsInput.dataset.values) return;

        const variantIdInput = this.form.querySelector('input[name="id"]');
        if (!variantIdInput) return;

        const variantId = variantIdInput.value;

        let valuesMap;
        try {
          valuesMap = JSON.parse(creditsInput.dataset.values);
        } catch (e) {
          console.error('Invalid data-values JSON on Credits input', e);
          return;
        }

        if (Object.prototype.hasOwnProperty.call(valuesMap, variantId)) {
          creditsInput.value = valuesMap[variantId];
        }
      }

      onSubmitHandler(evt, sub = false) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if(!sub) {
          this.updateCreditsProperty();
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let formData = new FormData(this.form);
        let {formDataUpdated, annualProduct, singleProduct} = this.manageCustomData(formData);
        formData = formDataUpdated;


        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      onSubmitHandlerExtended(evt, extraItems = [], bundleID) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
        this.handleErrorMessage();
      
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
      
        // Build the primary item from the form + any "additional option" logic,
        // reusing the existing manageCustomData() method untouched.
        let formData = new FormData(this.form);
        let { formDataUpdated } = this.manageCustomData(formData);
        formData = formDataUpdated;
      
        formData.append(`properties[_bundle]`, bundleID);

        const primaryItem = this.formDataToItem(formData);
      
        // Normalize extra items (fill in sensible defaults).
        const normalizedExtraItems = extraItems
          .filter((item) => item && item.id)
          .map((item) => ({
            id: item.id,
            quantity: item.quantity || 1,
            ...(item.properties ? { properties: item.properties } : {}),
            ...(item.selling_plan ? { selling_plan: item.selling_plan } : {}),
          }));
      
        const items = [primaryItem, ...normalizedExtraItems];
      
        const payload = { items };
      
        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
      
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(payload);
      
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: primaryItem.id,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
      
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
      
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: primaryItem.id,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
      
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
      
            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }
      
      formDataToItem(formData) {
        const item = {
          id: formData.get('id'),
          quantity: formData.get('quantity') || 1,
        };
      
        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) item.selling_plan = sellingPlan;
      
        const properties = {};
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = value;
        }
        if (Object.keys(properties).length) item.properties = properties;
      
        return item;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
